import {
    FETCH_COUNTRY_REQUEST,
    FETCH_COUNTRY_SUCCESS,
    FETCH_COUNTRY_FAILURE,
    FETCH_STATES_REQUEST,
    FETCH_STATES_SUCCESS,
    FETCH_STATES_FAILURE,
    FETCH_SPECIALTIES_REQUEST,
    FETCH_SPECIALTIES_SUCCESS,
    FETCH_SPECIALTIES_FAILURE,
    UPDATE_SELECTED_TYPE,
    SIGNUPMODAL,
    LOGINMODAL
} from "../actions/commonActions";

const initialState = {
    countries: [],
    states: [],
    specialities: [],
    selectedType: 'patient',
    regModal:false,
    loginModal:false,
    isLoading: false,
    error: null
};

export const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COUNTRY_REQUEST:
        case FETCH_STATES_REQUEST:
        case FETCH_SPECIALTIES_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_COUNTRY_SUCCESS:
            return { ...state, loading: false, countries: action.payload };

        case FETCH_STATES_SUCCESS:
            return { ...state, loading: false, states: action.payload };

        case FETCH_SPECIALTIES_SUCCESS:
            return { ...state, loading: false, specialities: action.payload };

        case FETCH_COUNTRY_FAILURE:
        case FETCH_STATES_FAILURE:
        case FETCH_SPECIALTIES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case UPDATE_SELECTED_TYPE:
            return { ...state, selectedType: action.payload };

        case SIGNUPMODAL:
            return{...state,regModal:action.payload};
        
        case LOGINMODAL:
            return{...state,loginModal:action.payload};

        default:
            return state;
    }
};